import React from 'react';
import "./RadialChartText.scss";

export default function RadialChartText() {
  return (
    <div className="chart-container ">
      <div className='blue-chart'>
        <div className="progress-overlay"></div>
        <div className="chart-text">75%</div>
      </div>
         <div className='burbl-chart'>
        <div className="progress-overlay"></div>
        <div className="chart-text">75%</div>
      </div>
         <div className='yellow-chart'>
        <div className="progress-overlay"></div>
        <div className="chart-text">75%</div>
      </div>
         <div className='red-chart'>
        <div className="progress-overlay"></div>
        <div className="chart-text">75%</div>
      </div>
      <div className='green-chart'>
        <div className="progress-overlay"></div>
        <div className="chart-text">75%</div>
      </div>
    </div>
  );
}